module.exports = __webpack_public_path__ + "static/images/section5img.cbc4223.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/section5img.png
// module id = m5Qd
// module chunks = 1